import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { ViewTitle } from '../components/reusable'
import { ILManagementView } from '../components/views/ILManagementView'

function ILManagement() {
    return (
        <div className="ilManagement">
            <Sidebar />
            <MainView>
                <ViewTitle text={'Irresponsible Lending Management'} />
                <ILManagementView />
            </MainView>
        </div>
    )
}

export default ILManagement
